// extracted by mini-css-extract-plugin
module.exports = {"alreadyBtn":"InputText_alreadyBtn__evqn0","inputContainer":"InputText_inputContainer__2LzlR","container":"InputText_container__HMGxJ","title":"InputText_title__11pFY"};